import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
// import Swiper JS
import Swiper from "swiper/bundle";
// import Swiper styles
import "swiper/css";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin)

export function stickySwipperComponent() {
  const initializeSwiper = () => {
    return new Swiper(".animatedSwiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      loop: false,
    });
  };

  let swiperInstance = null;
  let scrollTriggerInstance;

  // Function to manage Swiper and ScrollTrigger based on screen size
  const handleResponsiveFeatures = () => {
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;
  const isMobile = window.innerWidth <= 767;
  const cards = document.querySelectorAll(".themedCard");
    if (isPortrait) {
      // Initialize Swiper for mobile
      if (!swiperInstance) {
        swiperInstance = initializeSwiper();
      }
      if (scrollTriggerInstance) {
        // scrollTriggerInstance.disable();
        scrollTriggerInstance.kill();
        scrollTriggerInstance = null; // Clean up reference
      }
    } else {
      // Destroy Swiper for larger screens
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".slider-container", // Trigger on the slider container
          start: "top 100px", // Start when the container enters the viewport
          end: `+=${cards.length * 20}%`, // Extend the animation duration (300% viewport height)
          scrub: true, // Smooth scrubbing effect
          pin: true, // Pin the container
          markers: false, // Enable markers for debugging (optional)
          anticipatePin:1,
        //   snap: {
        //     snapTo: 'labels', // snap to the closest label in the timeline
        // }
        },
        ease: "none",
      });
      scrollTriggerInstance = tl.scrollTrigger;

      // const cards = document.querySelectorAll(".themedCard");

cards.forEach((card, index) => {
  const slideLabel = `slide_${index + 1}`;
  tl.add(slideLabel);

  if (index === 0) {
    // First card animation
    tl.to(card, { scale: 0.8, opacity: 0 });
  } else if (index === 1 && index !== cards.length - 1) {
    // Last card animation
    tl.to(card, { yPercent: -200 }, "<-=20%")
    .to(card, { scale: 0.8, opacity: 0 });
  } else if (index === cards.length - 1) {
    // Last card animation
    tl.to(card, { yPercent: -200 }, "<-=15%");
  } else {
    // Middle cards animation
    tl.to(card, { yPercent: -200 }, "<-=15%")
    .to(card, { scale: 0.8, opacity: 0 });
  }
});

      // tl.add('slide_1')
      // .to(".themedCard.blue", { scale: 0.8, opacity: 0 })
      // .add('slide_2')
      // .to(".themedCard.green", { yPercent: -200 }, "<-.2")
      // .to(".themedCard.green", { scale: 0.8, opacity: 0 })
      // .add('slide_3')
      //   .to(".themedCard.yellow", { yPercent: -200 }, "<-.2");

        document.querySelectorAll(".labelAnchor").forEach((anchor) => {
          anchor.addEventListener("click", (e) => {
            e.preventDefault(); // Prevent default anchor behavior
            const targetLabel = anchor.getAttribute("href").replace("#", ""); // e.g., "slide2"
            gsap.to(window, { scrollTo: tl.scrollTrigger.labelToScroll(targetLabel) });
          });
        });
    }
  };

  

  // Run on page load
  handleResponsiveFeatures();
  const debouncedHandleResponsiveFeatures = debounce(handleResponsiveFeatures, 300);
  // Listen for screen resize
  window.addEventListener("resize", function() {
    if (scrollTriggerInstance) {
      scrollTriggerInstance.kill();
      scrollTriggerInstance = null; // Clean up reference
    }
  })
  window.addEventListener("resize", debouncedHandleResponsiveFeatures);

  // window.addEventListener("resize", () => debounce(location.reload(), 300));
}

function debounce(func, wait) {
  let timeout;
  return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
